export default "__VITE_ASSET__DJDD0MTa__"